import '@theme/ncc-carousel-pagination';

/**
 * NCC: the quick-add ("Choose") modal in the Town Talk layout (Emma's Jira, 2026-09-15): Horizon morphs the
 * product page's product-information block into #quick-add-modal-content; the layout itself is CSS in
 * assets/ncc-theme.css ("Quick add modal"). This module adds the two pieces that markup cannot: the NCC bar
 * indicators under the one-at-a-time gallery (an <ncc-carousel-pagination> right after the media gallery,
 * which is where its component looks for the slideshow) and the "View more details" link under the buy
 * buttons (Horizon 4.1.5 styles a .view-more-details__wrapper but no longer renders one). Both are idempotent
 * and re-applied whenever the modal content changes (a new product, a variant re-render).
 */

const content = document.getElementById('quick-add-modal-content');
const translations = typeof Theme !== 'undefined' ? /** @type {any} */ (Theme).translations ?? {} : {};

function enhance() {
  if (!content) return;

  const gallery = content.querySelector('.product-information__media media-gallery');
  if (gallery?.querySelector('slideshow-component') && !gallery.nextElementSibling?.matches('ncc-carousel-pagination')) {
    const bars = document.createElement('ncc-carousel-pagination');
    bars.className = 'ncc-pagination ncc-quick-add__bars';
    bars.setAttribute('role', 'group');
    bars.setAttribute('aria-label', translations.slideshow ?? 'Slideshow');
    bars.hidden = true;
    bars.innerHTML = '<span class="ncc-pagination__bars" data-bars></span>';
    gallery.after(bars);
  }

  const details = content.querySelector('.product-details .group-block-content');
  const title = /** @type {HTMLAnchorElement | null} */ (content.querySelector('.view-product-title a[href]'));
  if (details && title && !details.querySelector('.ncc-quick-add__details')) {
    const wrapper = document.createElement('div');
    // Horizon's modal stylesheet hides everything in the details column except a whitelist that includes this class
    wrapper.className = 'view-more-details__wrapper ncc-quick-add__details';
    const link = document.createElement('a');
    link.className = 'view-more-details ncc-quick-add__details-link';
    link.href = title.href;
    link.textContent = translations.view_more_details ?? 'View more details';
    wrapper.append(link);
    details.append(wrapper);
  }
}

if (content) {
  new MutationObserver(enhance).observe(content, { childList: true, subtree: true });
  enhance();
}
